<p-editor
  [id]="id"
  [(ngModel)]="value"
  (ngModelChange)="onInternalChange($event)"
  (onBlur)="onInternalTouched()"
  [style]="style"
  [readonly]="disabled"
>
  <ng-template #header>
    <ng-container *ngIf="disabled; else toolbar">
    </ng-container>
    <ng-template #toolbar>
      <span class="ql-formats">
        <select class="ql-size">
          <option value="small">Klein</option>
          <option selected></option>
          <option value="large">Untertitel</option>
          <option value="huge">Titel</option>
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold" aria-label="Fett"></button>
        <button class="ql-italic" aria-label="Kursiv"></button>
        <button class="ql-underline" aria-label="Unterstrichen"></button>
        <button class="ql-strike" aria-label="Durchgestrichen"></button>
      </span>
      <span class="ql-formats">
       <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
          <option value="rgb(0, 0, 0)" label="rgb(0, 0, 0)"></option>
          <option value="rgb(61, 20, 102)" label="rgb(61, 20, 102)"></option>
          <option value="rgb(255, 0, 0)" label="rgb(255, 0, 0)"></option>
          <option value="rgb(255, 153, 0)" label="rgb(255, 153, 0)"></option>
          <option value="rgb(255, 255, 0)" label="rgb(255, 255, 0)"></option>
          <option value="rgb(0, 128, 0)" label="rgb(0, 128, 0)"></option>
          <option value="rgb(0, 0, 255)" label="rgb(0, 0, 255)"></option>
          <option value="rgb(153, 51, 255)" label="rgb(153, 51, 255)"></option>
         <option value="rgb(255, 255, 255)" label="rgb(255, 255, 255)"></option>
        </select>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-list" aria-label="List" value='ordered'></button>
        <button type="button" class="ql-list" aria-label="Bullet" value='bullet'></button>
      </span>
      <span class="ql-formats">
      <select title="Text Alignment" class="ql-align">
        <option selected>Links</option>
        <option value="justify" label="Justify"></option>
        <option value="center" label="Mittig"></option>
        <option value="right" label="Rechts"></option>
      </select>
      </span>
      <span class="ql-formats">
        <button aria-label="Link" class="ql-link"></button>
      </span>
    </ng-template>
  </ng-template>
</p-editor>
